import { IOfferState } from '../../redux/reducers';

export const getLocationPath = (offer: IOfferState) => {
  const details = offer && offer.geo && offer.geo.details || [];

  return details.filter(({ geoType }) => geoType === 'location')
    .map(({ id }) => id);
};
